export default "__VITE_ASSET__BUUPeWsM__"